









import { Vue, Component } from 'vue-property-decorator'
import { ITreeselectNode } from '@riophae/vue-treeselect'
import Treeselect from '@/reusable/components/treeselect.vue'

@Component({
  components: {
    Treeselect
  },
})
export default class LanguageSelectorComponent extends Vue {
  get options (): ITreeselectNode[] {
    return this.$i18n.availableLocales
      .map((locale) => {
        return { id: locale, label: locale.toUpperCase() }
      })
  }

  public handleInput (locale: string) {
    window.localStorage.setItem('locale', locale)
  }
}
